import styled from 'styled-components';
import isNumber from 'lodash/isNumber';
import { ListAction } from 'modules/campaigns/editor/types';
import { CircleSpinner } from 'ui/spinner';
import { spacing, colors, body2, overline } from 'ui/theme';
import { AudienceList } from 'modules/domains/campaign';
import { getListText } from './utils';
import { CalculateSelectedListsSizesState } from '../../../hooks';
import { ListCard } from './ListCard';

export const LIST_DETAIL_TEST_ID = 'list-detail';
export const LIST_DETAIL_TYPE_TEST_ID = `${LIST_DETAIL_TEST_ID}-type`;
export const LIST_DETAIL_TOTAL_TEST_ID = `${LIST_DETAIL_TEST_ID}-total`;
export const LIST_DETAIL_TOTAL_LOADING_TEST_ID = `${LIST_DETAIL_TEST_ID}-total-loading`;

const ListDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  margin: 0;
  padding: 0;
`;

const ListDetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${colors.secondaryText};
  border-bottom: 1px solid ${colors.grey15};

  padding: ${spacing.base} 0 ${spacing.threeQuarter} 0;
  ${overline}
`;

const ListDetailBody = styled.ul`
  margin-left: 0px;
  list-style-type: none;
  padding: 0;
  gap: 10px;
  display: flex;
  flex-direction: column;
`;

const ListsContactsTotal = styled.span`
  gap: ${spacing.quarter};
  display: inline-flex;
  ${overline}
`;

type ListDetailProps = {
  listType: ListAction;
  list: AudienceList[];
  onRemove: (item: AudienceList) => void;
  selectedListsSizes: CalculateSelectedListsSizesState;
};

const TotalContactsCount = ({ totalRecipients }: { totalRecipients?: number }) => (
  <span>
    {isNumber(totalRecipients)
      ? `${totalRecipients} ${getListText(totalRecipients as number)}`
      : ''}
  </span>
);

export const ListDetail = ({ listType, list, onRemove, selectedListsSizes }: ListDetailProps) => {
  const {
    isLoading: isLoadingTotalContacts,
    totalRecipients,
    selectedListsSizesById,
  } = selectedListsSizes;

  return (
    <ListDetailWrapper data-test={LIST_DETAIL_TEST_ID}>
      <ListDetailHeader>
        <span data-test={LIST_DETAIL_TYPE_TEST_ID}>{listType}</span>
        <ListsContactsTotal data-test={LIST_DETAIL_TOTAL_TEST_ID}>
          {isLoadingTotalContacts ? (
            <CircleSpinner size={body2.fontSize} data-test={LIST_DETAIL_TOTAL_LOADING_TEST_ID} />
          ) : (
            <TotalContactsCount totalRecipients={totalRecipients} />
          )}
        </ListsContactsTotal>
      </ListDetailHeader>
      <ListDetailBody>
        {list.map((listItem: AudienceList) => {
          const listSizeData = selectedListsSizesById?.[listItem?.id] ?? {};

          return (
            <ListCard
              id={listItem.id}
              listType={listType}
              key={listItem.id}
              name={listItem.name}
              removeList={onRemove}
              listSizeData={listSizeData}
            />
          );
        })}
      </ListDetailBody>
    </ListDetailWrapper>
  );
};
